<template>
  <IziGrid class="profile-user-container">
    <IziCol xl="4" lg="4" md="4" col="12">
      <IziCard class="card-menuleft">
        <DataTable
          :value="dataProfile"
          selectionMode="single"
          data-key="id"
          @row-select="onRowSelect"
        >
          <Column field="name" header="iZi_Best">
            <template #body="slotProps">
              <div
                class="row-challenge-type"
                :class="{
                  'coming-soon': slotProps.data.comingsoon,
                  selected: slotProps.data.id === challengeType
                }"
              >
                <div class="title">
                  <IziIcon>{{ slotProps.data.icon }}</IziIcon>
                  <span>{{ slotProps.data.name }}</span>
                </div>
                <span class="description">{{ slotProps.data.description }}</span>
              </div>
            </template>
          </Column>
        </DataTable>
      </IziCard>
    </IziCol>
    <IziCol xl="8" lg="8" md="8" col="12" class="templates">
      <div v-for="(setting, index) in selected.settings" :key="index">
        <Panel class="list-template" :toggleable="true" :collapsed="false">
          <component :is="setting.name" />
        </Panel>
      </div>
    </IziCol>
  </IziGrid>
</template>

<script lang="ts">
import Base from "../base/Base.vue";
import { Options } from "vue-class-component";
import AllProfile from "./index";
import { watchEffect } from "vue";
@Options({
  components: AllProfile
})
export default class ProfileUser extends Base {
  public selected: any = {};
  challengeType = 1;

  created() {
    watchEffect(() => {
      this.selected = this.dataProfile.find(
        (s: any) => s.id === this.challengeType
      ) as any;
    })
  }

  dataProfile = [
    {
      id: 1,
      name: "Profile",
      description: "",
      icon: "account_circle",
      settings: [{ id: 0, name: "InfoProfile" }]
    },
    {
      id: 2,
      name: "My Collection",
      description: "",
      icon: "all_inbox",
      settings: [{ id: 0, name: "MyChallenge" }]
    },
    {
      id: 3,
      name: "History",
      description: "Coming soon",
      icon: "restore",
      settings: [],
      comingsoon: true
    }
  ];

  onRowSelect(event: any) {
    if (event.data.settings > 0) {
      this.selected = event.data;
    }
    this.challengeType = event.data.id;
  }
}
</script>
<style lang="scss">
.profile-user-container {
  font-weight: bold;
  background-color: #ffffff;
  height: 100%;
  .card-menuleft {
    .col-title {
      text-transform: uppercase;
      text-align: center;
    }
    .p-datatable .p-datatable-thead > tr > th {
      color: $text-color-content;
      text-align: center;
      font-weight: bold;
      font-size: 25px;
      .p-column-title {
        color: #dadada;
      }
    }
    .p-datatable .p-datatable-tbody > tr > td {
      padding: 0px;
      color: $text-color-content;
      font-weight: bold;
      .row-challenge-type {
        padding: 0.75rem 0.75rem;
        min-height: 100px;
        padding-top: 30px;
        .title {
          align-items: center;
          display: flex;
          font-size: 25px;
        }

        .description {
          font-size: 12px;
        }
        &.selected {
          background: rgba(0, 0, 0, 0.04);
        }
        &.coming-soon {
          color: #dadada;
        }
      }
    }
    .col-action-settings {
      text-align: right;
      .next {
        width: 150px;
        .p-button-label {
          font-weight: bold;
        }
      }
    }
    .p-panel .p-panel-header .p-panel-title {
      font-weight: bold;
      color: $text-color-content;
    }
  }
  .my-challenge {
    .p-datatable .p-datatable-thead > tr > th {
      color: #4d1a19;
      font-weight: bold;
    }
  }
}
</style>
